import grass from "../assets/Types/Grass.png";
import fire from "../assets/Types/Fire.png";
import water from "../assets/Types/Water.png";
import electric from "../assets/Types/Electric.png";
import psychic from "../assets/Types/Psychic.png";
import fighting from "../assets/Types/Fight.png";
import flying from "../assets/Types/Flying.png";
import poison from "../assets/Types/Poison.png";
import ground from "../assets/Types/Ground.png";
import rock from "../assets/Types/Rock.png";
import bug from "../assets/Types/Bug.png";
import ice from "../assets/Types/Ice.png";
import ghost from "../assets/Types/Ghost.png";
import dark from "../assets/Types/Dark.png";
import steel from "../assets/Types/Steel.png";
import dragon from "../assets/Types/Dragon.png";
import normal from "../assets/Types/Normal.png";
import fairy from "../assets/Types/Fairy.png";

export default {
    "grass": grass,
    "fire": fire,
    "water": water,
    "electric": electric,
    "psychic": psychic,
    "fighting": fighting,
    "flying": flying,
    "poison": poison,
    "ground": ground,
    "rock": rock,
    "bug": bug,
    "ice": ice,
    "ghost": ghost,
    "dark": dark,
    "steel": steel,
    "dragon": dragon,
    "normal": normal,
    "fairy": fairy
}